<template>
  <div
    :class="{
      'condition-selector': true,
      'condition-selector__outlined': outlined,
    }"
  >
    <SelectBox
      v-model="selectedItem"
      :items="items"
      :outlined="false"
      flat
      solo
      clear
      selection-slot
      item-slot
      is-attached
      :disabled="disabled"
    >
      <template #selection="{ item }">
        <div class="condition-selector__selection">
          <span class="condition-selector__selection--text">
            {{ item?.text || '' }}
          </span>
          <v-chip
            v-if="defaultItem?.value !== item?.value && badgeText"
            small
            color="$primaryLight"
          >
            <span class="condition-selector__badge--text">{{ badgeText }}</span>
          </v-chip>
        </div>
      </template>
      <template #item="{ item }">
        <div
          class="condition-selector__selected-item"
          :data-testid="item?.text || ''"
        >
          <span class="items--text">{{ item?.text || '' }}</span>
        </div>
      </template>
    </SelectBox>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SelectBox from '../SelectBox.vue';

type Item = {
  text: string;
  value: string;
};

type Props = {
  disabled?: boolean;
  value?: any;
  items: (Item | string)[];
  badgeText?: string;
  defaultItem?: Item;
  outlined?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  outlined: false,
});

const emit = defineEmits<{
  (e: 'input', value: any): void;
  (e: 'blur'): void;
}>();

const selectedItem = computed({
  get: () => props.value,
  set: (newValue) => {
    if (newValue !== props.value) {
      emit('input', newValue);
    }
  },
});
</script>

<style lang="scss">
@import '../../../assets/styles/main';

.condition-selector {
  min-height: 40px;
  height: 40px;

  &__selection {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__badge--text {
    width: max-content;
  }

  &__selected-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__outlined {
    min-height: 40px;
    height: 40px;
    width: 100%;
    border: 1px solid $elements;
    border-radius: 4px;
    background-color: $backgrounds;
  }

  .v-input {
    max-height: 35px;
  }

  .v-input__control:hover {
    background-color: none;
  }

  .select-box .v-input__slot {
    &:hover {
      box-shadow: none !important;
      border: none !important;
    }
  }

  .v-select--is-menu-active {
    background: $backgrounds !important;
    max-height: 35px;
  }

  .v-chip {
    background: $primaryLight !important;
    color: $primaryWhite !important;
    min-width: max-content;
  }

  input {
    display: none !important;
  }
}

.select-box--clear .v-input__control .v-input__slot {
  background: transparent !important;
}

.condition-selector__selection--text {
  @include body-2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.items--text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
